import React, { useEffect } from 'react';

import { page } from '@randajan/jet-react/base/page';
import { usePop } from '@randajan/jet-react/dom/modal';



export const usePopRouter = (pagePath, routes={}, renderer=v=>v, isReady=true)=>{  
    const [base] = page.use(pagePath);

    const pop = usePop({ onDown: _ => base.remove() });

    useEffect(_ => {
        if (!isReady) { return; }
        const onChange = _ => {
            const doc = routes?.[base.get()];
            if (!doc) { pop.down(); return; }
            pop.up(renderer(doc));
        };
        onChange();
        return base.watch("", onChange);
    }, [routes]);

    return path=>base.set("", path);
}

